import { Table, Tabs, message } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import { ColumnProps } from 'antd/lib/table';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import { DOCTOR_TYPE_ISCERTIFICATED, DOCTOR_TYPE_ISPASS, DOCTOR_DETAIL_SOURCE, DOCTOR_TYPE_REJECT } from 'src/constants/ActionTypes';
import AuditSearch from 'src/containers/AuditSearch';
import { IPageResult } from 'src/entity/BaseResult';
import { IAuditListColumnData } from 'src/entity/ColumnDataEntity';
import { IDoctorInfo } from 'src/entity/DoctorEntity';
import { fetchLocationsIfNeeded } from 'src/redux/actions/locationCreator';
import { selectDoctor } from 'src/redux/actions/selectDoctorCreator';
import I18N from 'src/services/I18NService';
import { UtilDateTime } from 'src/utils/datetime';
import DoctorService from 'src/services/DoctorService';
import { IStateCollection } from 'src/entity/StateEntity';
import { fetchMallPharmacyIfNeeded } from 'src/redux/actions/mallPharmacyCreator';

interface IDoctorAuditListProps extends RouteComponentProps {
  isDomestic: boolean;
  dispatch: Dispatch<IStateCollection>;
}

interface IDoctorAuditListState {
  loadingTable: boolean;
  columns: Array<ColumnProps<IAuditListColumnData>>;
  dataSource: IAuditListColumnData[];
  paginationFirst: PaginationProps;
  paginationSecond: PaginationProps;
  paginationThird: PaginationProps;
  selectTab: number;
}

class DoctorAuditListPage extends React.Component<IDoctorAuditListProps, IDoctorAuditListState> {
  tablePagination = false;
  child: any;

  constructor(props: IDoctorAuditListProps) {
    super(props);

    const columns: Array<ColumnProps<IAuditListColumnData>> = [
      {
        title: I18N.get('common_rowNum'),
        key: 'index',
        dataIndex: 'index',
      },
      {
        title: I18N.get('common_name'),
        key: 'name',
        dataIndex: 'name',
      },
      {
        title: this.props.isDomestic ? I18N.get('common_mobile') : 'email',
        key: this.props.isDomestic ? 'phone' : 'email',
        dataIndex: this.props.isDomestic ? 'phone' : 'email',
      },
      {
        title: I18N.get('common_create_time'),
        key: 'createTime',
        dataIndex: 'createTime',
      },
      {
        title: I18N.get('common_status'),
        key: 'status',
        dataIndex: 'status',
      },
      {
        title: I18N.get('common_operation'),
        dataIndex: 'operation',
        key: 'operation',
        render: (text: any, record: IAuditListColumnData, index: number): React.ReactNode => {
          return this.state.dataSource.length > 0 ? (
            <div>
              <a onClick={() => this.handleDoctorDetail(record)}>{I18N.get('common_detail')}</a>
            </div>
          ) : null;
        },
      },
    ];
    this.state = {
      loadingTable: false,
      columns,
      dataSource: [],
      paginationFirst: {},
      paginationSecond: {},
      paginationThird: {},
      selectTab: 1, // 默认是待审核
    } as IDoctorAuditListState;
  }

  async componentDidMount() {
    this.child.doSearch();
    // 获取单元药库数据
    this.props.dispatch(fetchMallPharmacyIfNeeded());
    // 获取地址信息
    this.props.dispatch(fetchLocationsIfNeeded());
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  onRefAuditSearch = (ref: any) => {
    this.child = ref;
  };

  getDateTimeFormat = (dt: string): string => {
    if (!!dt) {
      return UtilDateTime.datetimeFormat('yyyy-MM-dd', new Date(dt));
    }
    return '';
  };

  doctorInfo2TableData = (dataList: IDoctorInfo[], status: string, current: number | undefined, pageSize: number | undefined): IAuditListColumnData[] => {
    const result: IAuditListColumnData[] = [];
    for (let i = 0, len = dataList.length; i < len; i++) {
      const obj = dataList[i] as IDoctorInfo;
      result.push({
        key: obj.uuid,
        index: !!pageSize ? i + 1 + (Number(current) - 1) * pageSize : i + 1,
        name: obj.last_name + obj.first_name,
        phone: obj.mobile || '',
        email: obj.email || '',
        createTime: this.getDateTimeFormat(obj.created_time),
        status,
        doctorObj: obj,
      });
    }
    return result;
  };

  handleSearch = (result: IPageResult<IDoctorInfo[]>): void => {
    if (!!result && !!result.results) {
      this.setState({
        loadingTable: true,
      });

      let status = '';
      let pagination: PaginationProps | undefined;
      switch (this.state.selectTab) {
        case 1:
          status = I18N.get('common_status_pending');
          pagination = { ...this.state.paginationFirst };
          break;
        case 2:
          status = I18N.get('common_status_to_certified');
          pagination = { ...this.state.paginationSecond };
          break;
        case 3:
          status = I18N.get('common_status_rejected');
          pagination = { ...this.state.paginationThird };
          break;
      }
      if (!!pagination) {
        const dataList = this.doctorInfo2TableData(result.results || [], status, pagination.current, pagination.pageSize);
        pagination.total = result.count;
        if (!this.tablePagination) {
          pagination.current = 1;
        }

        switch (this.state.selectTab) {
          case 1:
            this.setState({
              dataSource: dataList,
              loadingTable: false,
              paginationFirst: pagination,
            });
            break;
          case 2:
            this.setState({
              dataSource: dataList,
              loadingTable: false,
              paginationSecond: pagination,
            });
            break;
          case 3:
            this.setState({
              dataSource: dataList,
              loadingTable: false,
              paginationThird: pagination,
            });
            break;
        }
      }
    }
    this.tablePagination = false;
    // if (this.state.selectTab === 1 || this.state.selectTab === 3) {
    //   const status = this.state.selectTab === 1 ? I18N.get('common_status_pending') : I18N.get('common_status_rejected');
    //   // 待审核列表
    //   const pagination: PaginationProps = { ...this.state.paginationFirst };
    //   if (!!result && !!result.results) {
    //     pagination.total = result.count;
    //     if (!this.tablePagination) {
    //       pagination.current = 1;
    //     }
    //     for (let i = 0, len = result.results.length; i < len; i++) {
    //       const obj = result.results[i] as IDoctorInfo;
    //       dataList.push({
    //         key: obj.uuid,
    //         index: !!pagination.pageSize ? i + 1 + (Number(pagination.current) - 1) * pagination.pageSize : i + 1,
    //         name: obj.last_name + obj.first_name,
    //         phone: obj.mobile || '',
    //         email: obj.email || '',
    //         createTime: this.getDateTimeFormat(obj.created_time),
    //         status,
    //         doctorObj: obj,
    //       });
    //     }
    //   }
    //   this.setState({
    //     dataSource: dataList,
    //     loadingTable: false,
    //     paginationFirst: pagination,
    //   });
    // } else if (this.state.selectTab === 2) {
    //   // 待认证列表
    //   const pagination: PaginationProps = { ...this.state.paginationSecond };
    //   if (!!result && !!result.results) {
    //     pagination.total = result.count;
    //     if (!this.tablePagination) {
    //       pagination.current = 1;
    //     }
    //     for (let i = 0, len = result.results.length; i < len; i++) {
    //       const obj = result.results[i] as ICertificationDoctorInfo;
    //       dataList.push({
    //         key: obj.uuid,
    //         index: !!pagination.pageSize ? i + 1 + (Number(pagination.current) - 1) * pagination.pageSize : i + 1,
    //         name: obj.last_name + obj.first_name,
    //         phone: obj.mobile || '',
    //         email: obj.email || '',
    //         createTime: this.getDateTimeFormat(obj.created_time),
    //         status: I18N.get('common_status_to_certified'),
    //         doctorObj: obj,
    //       });
    //     }
    //   }
    //   this.setState({
    //     dataSource: dataList,
    //     loadingTable: false,
    //     paginationSecond: pagination,
    //   });
    // }
    // else if (this.state.selectTab === 3) {
    //   // 审核驳回医生列表
    //   const pagination: PaginationProps = { ...this.state.paginationThird };
    //   if (!!result && !!result.results) {
    //     pagination.total = result.count;
    //     if (!this.tablePagination) {
    //       pagination.current = 1;
    //     }
    //     for (let i = 0, len = result.results.length; i < len; i++) {
    //       const obj = result.results[i] as IDoctorInfo;
    //       dataList.push({
    //         key: obj.uuid,
    //         index: !!pagination.pageSize ? i + 1 + (Number(pagination.current) - 1) * pagination.pageSize : i + 1,
    //         name: obj.last_name + obj.first_name,
    //         phone: obj.mobile || '',
    //         email: '',
    //         createTime: this.getDateTimeFormat(obj.created_time), // 审核驳回医生注册时间取reg_time
    //         status: I18N.get('common_status_rejected'),
    //         doctorObj: obj,
    //       });
    //     }
    //   }
    //   this.setState({
    //     dataSource: dataList,
    //     loadingTable: false,
    //     paginationThird: pagination,
    //   });
    // }
  };

  handleTableOnChange = (pagination: PaginationProps, filters: any, sorter: any) => {
    this.tablePagination = true;
    if (this.state.selectTab === 1) {
      const pager: PaginationProps = { ...this.state.paginationFirst };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.setState({
        paginationFirst: pager,
      });
      if (!!pager.current && Number(pager.current) > 0) {
        this.child.doSearch(this.state.selectTab, (pager.current - 1) * Number(pagination.pageSize), pagination.pageSize);
      }
    } else if (this.state.selectTab === 2) {
      const pager: PaginationProps = { ...this.state.paginationSecond };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.setState({
        paginationSecond: pager,
      });
      if (!!pager.current && Number(pager.current) > 0) {
        this.child.doSearch(this.state.selectTab, (pager.current - 1) * Number(pagination.pageSize), pagination.pageSize);
      }
    } else if (this.state.selectTab === 3) {
      const pager: PaginationProps = { ...this.state.paginationThird };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.setState({
        paginationThird: pager,
      });
      if (!!pager.current && Number(pager.current) > 0) {
        this.child.doSearch(this.state.selectTab, (pager.current - 1) * Number(pagination.pageSize), pagination.pageSize);
      }
    }
  };

  handleDoctorDetail = async (record: IAuditListColumnData) => {
    const { match } = this.props;
    const doctorId = record.doctorObj.id;
    let detailType: DOCTOR_DETAIL_SOURCE | undefined;
    switch (this.state.selectTab) {
      case 1:
        // 待审核医生详情
        detailType = DOCTOR_TYPE_ISPASS;
        break;
      case 2:
        // 待认证医生详情
        detailType = DOCTOR_TYPE_ISCERTIFICATED;
        break;
      case 3:
        // 已驳回医生详情
        detailType = DOCTOR_TYPE_REJECT;
        break;
      default:
        break;
    }
    try {
      if (!!doctorId && !!detailType) {
        // const doctorInfoObj = record.doctorObj as IDoctorInfo;
        const doctorInfoObj = await DoctorService.getAgentDoctorInfo(doctorId);
        switch (detailType) {
          case DOCTOR_TYPE_ISPASS:
            // 待审核医生详情接口
            // doctorInfoObj = await DoctorService.getAgentDoctorInfo(doctorId);
            // doctorInfoObj = record.doctorObj as IDoctorInfo;
            // doctorInfoObj = await DoctorService.getDoctorMemberInfo(doctorUUID);
            break;
          case DOCTOR_TYPE_ISCERTIFICATED:
            const certificationInfo = record.doctorObj; // TODO:@CHENKAI 是否需要转换？
            // // 待认证医生详情接口
            // const recordId = record.key;
            // const certificationInfo = await DoctorService.getAgentDoctorCertificationInfo(recordId);
            // // 用外层[身份证|医师资格证]等字段替换医生对象中对应字段
            doctorInfoObj.id_card = certificationInfo.id_card;
            doctorInfoObj.id_card2 = certificationInfo.id_card2;
            doctorInfoObj.certificate = certificationInfo.certificate;
            doctorInfoObj.certificate2 = certificationInfo.certificate2;
            break;
          case DOCTOR_TYPE_REJECT:
            // 已驳回医生详情接口
            // doctorInfoObj = await DoctorService.getAgentDoctorRejectInfo(doctorId);
            break;
        }

        if (!!doctorInfoObj) {
          this.props.dispatch(selectDoctor(doctorInfoObj, detailType));
          this.props.history.push(`${match.path}/${record.key}`);
        } else {
          console.error('getAgentDoctorInfo: 后台返回数据错误');
        }
      }
    } catch (error) {
      message.error('服务器报错');
      console.error(error);
    }
  };

  changeTabs = (key: string) => {
    this.setState({
      selectTab: Number(key),
    });
    this.child.doSearch(Number(key));
  };

  render() {
    return (
      <div>
        <AuditSearch selectTab={this.state.selectTab} onRef={this.onRefAuditSearch} cbSearch={this.handleSearch} />
        <Tabs defaultActiveKey="1" onChange={this.changeTabs}>
          <Tabs.TabPane tab={I18N.get('common_status_pending')} key="1">
            <Table
              loading={this.state.loadingTable}
              columns={this.state.columns}
              pagination={this.state.paginationFirst}
              dataSource={this.state.dataSource}
              onChange={this.handleTableOnChange}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={I18N.get('common_status_to_certified')} key="2">
            <Table
              loading={this.state.loadingTable}
              columns={this.state.columns}
              pagination={this.state.paginationSecond}
              dataSource={this.state.dataSource}
              onChange={this.handleTableOnChange}
            />
          </Tabs.TabPane>
          {this.props.isDomestic && (
            <Tabs.TabPane tab={I18N.get('common_status_rejected')} key="3">
              <Table
                loading={this.state.loadingTable}
                columns={this.state.columns}
                pagination={this.state.paginationThird}
                dataSource={this.state.dataSource}
                onChange={this.handleTableOnChange}
              />
            </Tabs.TabPane>
          )}
        </Tabs>
      </div>
    );
  }
}

export default DoctorAuditListPage;



// WEBPACK FOOTER //
// ./src/components/views/Doctor/DoctorAuditListPage.tsx